
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'minus': {
    width: 12,
    height: 2,
    viewBox: '0 0 12 2',
    data: '<path pid="0" class="st1" d="M0 0h12v2H0z"/>'
  }
})
